var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCar1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.94314 40.4141H6.20763C4.18799 40.4141 2.55078 38.7768 2.55078 36.7573V29.5638C2.55078 28.594 2.93612 27.6639 3.62181 26.9781L12.4041 18.1958C14.143 16.4569 16.5014 15.4801 18.9603 15.4801H34.115C35.6551 15.4801 37.1322 16.092 38.2212 17.181L47.365 26.3247L56.6468 29.3436C57.9004 29.7514 58.7491 30.9198 58.7491 32.2381V37.3703C58.7491 39.0513 57.3863 40.4141 55.7053 40.4141H53.3567",
    stroke: "#03395A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4375 40.4141H42.8642",
    stroke: "#03395A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1094 16.3119V19.7502C15.1094 23.3786 18.051 26.3203 21.6794 26.3203H47.3616",
    stroke: "#03395A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6523 26.3203V15.4756",
    stroke: "#03395A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0977 32.1562H37.21",
    stroke: "#03395A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4349 40.4095C18.4349 43.3072 16.0858 45.6562 13.1881 45.6562C10.2904 45.6562 7.94141 43.3072 7.94141 40.4095C7.94141 37.5118 10.2904 35.1628 13.1881 35.1628C16.0858 35.1628 18.4349 37.5118 18.4349 40.4095Z",
    stroke: "#03395A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3567 40.4095C53.3567 43.3072 51.0078 45.6562 48.11 45.6562C45.2123 45.6562 42.8633 43.3072 42.8633 40.4095C42.8633 37.5118 45.2123 35.1628 48.11 35.1628C51.0078 35.1628 53.3567 37.5118 53.3567 40.4095Z",
    stroke: "#03395A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar1);
export default __webpack_public_path__ + "static/media/car1.440598a44bc917cd84b0a816a2678461.svg";
export { ForwardRef as ReactComponent };